module.exports = __webpack_public_path__ + "img/12-vogelspeelgoed.10f4278f.jpg";